import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const stepStyles = {
  step: css`
    .step__header-title {
      font-size: ${theme.font.size.h3};
    }
  `,
};
